import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../controls/Modal';
import LabeledInput from '../../../controls/LabeledInput';

function defaultStart() {
    const now = new Date();
    now.setHours(20, 0, 0, 0);
    return now.toISOString().slice(0, 16);
}

function toLocalInput(dateStr) {
    const d = new Date(dateStr);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Модалка создания/редактирования мероприятия. С event → режим редактирования.
export default function CreateActivityModal({ event, onSubmit, onClose }) {
    const [form, setForm] = useState(() => (event
        ? { title: event.title || '', startTime: toLocalInput(event.startTime) }
        : { title: '', startTime: defaultStart() }));

    const set = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));
    const valid = form.title.trim() && form.startTime;

    const submit = async () => {
        if (!valid) return;
        try {
            await onSubmit({ title: form.title.trim(), startTime: form.startTime });
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };

    return (
        <Modal
            open
            kicker="Мероприятие"
            title={event ? 'Изменить мероприятие' : 'Создать мероприятие'}
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-primary" onClick={submit} disabled={!valid}>{event ? 'Сохранить' : 'Создать'}</button>
                </>
            )}
        >
            <LabeledInput label="Название" value={form.title} onChange={set('title')} placeholder="Например, Квест" />
            <LabeledInput label="Время начала" type="datetime-local" value={form.startTime} onChange={set('startTime')} />
        </Modal>
    );
}

CreateActivityModal.propTypes = {
    event: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

CreateActivityModal.defaultProps = { event: null };
